import BaseClientError from "@/core/errors/BaseClientError";

export default class ApplicationsError extends BaseClientError {
  constructor(error: unknown, applicationType: string) {
    super(error, `la ${applicationType}`);
  }
}
